export class Constants {
  public static Cookie = {
    User: "sx_wbus",
    Auth_Info: "sx_auth_info"
  };

  public static Storage_Local = {
    Search: { key: "sx_search", count: 20 },
    Login_Name: "sx_login_name",
    Read_Process: "sx_read_process",
    Read_Background: "sx_read_bg",
    ReadEye_Background: "nr_readEye_bg",
    Read_Font_Size: "sx_read_font_size",
    Audio_Process: "sx_audio_process",
    Calender_Open: "sx_calender_open",
    BookDetail_TabIndex: "sx_bookdetail_tabindex",//图书详情页上次浏览的tab
    AudioPlay_TabIndex: "sx_audioplay_tabindex",//听书详情页上次浏览的tab
    EditCommentText: "sx-edit-comment-text",//图书评论
    Auth_Handle_Step: "sx-auth_handle_step",//机构认证操作记录
    Read_Theme_Font:'sx-read-theme-font', //阅读页面主题设置以及字体大小
    Login_Time: "sx_login_time", //记录登录时间
    Check_Lock_Prompt_Book:"sx_check_lock_prompt_book",
    Check_Lock_Prompt_Audio:"sx_check_lock_prompt_audio",
  };

  public static Storage_Session = {
    App_Info: "sx_app_info",
    App_Config: "sx_app_conf",
    Boot_State: "sx_boot_state",
    App_Index: "sx_channel_topic",
    History_Url: "sx_history_url",
    Index_Sel_Channel: "sx_index_sel_channel",
    Classify_Book: "sx_classify_book",
    Classify_Audio: "sx_classify_audio",
    Return_Url: "sx_return_url",
    Login_After_Url: "sx_login_after_url",
    Reader_Verify: "sx_reader_verify",
    Index_Publisher: "sx_index_publisher",
    Keyword: "sx_keyword",
    Tips_Once: "sx_tips",
    Ext_Prompt_Flag: "sx_ext_prompt_flag",
    Repeat_Login_Info: "sx_repeat_login_info",
    Repeat_Login_Win: "sx_repeat_login_win", //有此标识自动打开快捷登录窗口
    Zwzy_Baidu_Label:"sx_zwzy_baidu_label",
  };

  public static Error = {
    Api_Denial: { code: "100403", text: "接口访问权限受限!" },
    NO_Authentication: { code: "00012", text: "访问权限受限!" },
    Server_Error: { code: "06002", text: "服务处理异常!" },
    Need_Login: { code: "06201", text: "需要先登录!" },
    Token_Invalid: { code: "06202", text: "Token无效,请刷新重试!" },
    App_Expired: { code: "06105", text: "机构服务已到期!" },
    Kickout_Login: { code: "06222", text: "账号在别处登录,请重新登录!" },
    User_Expired: { code: "06224", text: "用户账号已过有效期,请联系管理员!" },
    Binding_Phone: { code: "06210", text: "需绑定手机号!" },
  };

  public static Res_Type = {
    Book: {
      All: { key: "all", text: "为您提供{0}册精选好书" },
      Topic: { key: "topic", text: "" },
      Rank: { key: "rank", text: "图书排行榜" },
      //Famous: { key: "famous", text: "" },
      Author: { key: "author", text: "" },
      Publisher: { key: "publisher", text: "" },
      Theme: { key: "theme", text: "" }, //专题图书列表路由
    },
    Audio: {
      //All: { key: "all", text: "为您提供{0}部{1}集优质有声听书" },
      All: { key: "all", text: "为您提供{0}集优质有声听书" },
      Topic: { key: "topic", text: "" },
      Rank: { key: "rank", text: "听书排行榜" },
      Theme: { key: "theme", text: "" }, //专题听书列表路由
    },
  };

  public static Rank_Topic_Code = {
    Click: {
      Book: {
        Day: "mobile_book_dayClickList",
        Week: "mobile_book_weeklyClickList",
        Month: "mobile_book_monthClickList",
        Total: "mobile_book_totalClickList",
      },
      Audio: {
        Day: "mobile_audio_dayClickList",
        Week: "mobile_audio_weeklyClickList",
        Month: "mobile_audio_monthClickList",
        Total: "mobile_audio_totalClickList",
      },
    },
    Time: {
      All: {
        // Day: "rank_time_book_day",
        // Week: "rank_time_book_week",
        // Month: "rank_time_book_month",
        // Total: "rank_time_book_total",
        Day: "DAY",
        Week: "WEEK",
        Month: "MONTH",
        Total: "TOTAL",
      },
      Book: {
        Day: "DAY",
        Week: "WEEK",
        Month: "MONTH",
        Total: "TOTAL",
      },
      Audio: {
        Day: "DAY",
        Week: "WEEK",
        Month: "MONTH",
        Total: "TOTAL",
      },
    },
  };

  public static Commons_Static = {
    Img_Base_Url: "//sx-imgs.oss-cn-zhangjiakou.aliyuncs.com/wxyyd",
    Css_Base_Url: "//sx-assets.oss-cn-zhangjiakou.aliyuncs.com/css",
  };

  public static Audio_Episode_PageSize = 10; // 目录分页大小

  public static Activity_static = "static-topic"; // 专题字段

  public static Report_ReadTime_Interval = 180; // 上报阅读听书时长频率(秒)
}
